"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSchema = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _zod = require("zod");
var _useTranslations = require("./hooks/useTranslations");
var _TranslationKey = require("./models/TranslationKey");
const useGetSchema = config => {
  const {
    telephoneNumber
  } = config;
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  let schema = _zod.z.object({
    connectWithWhatsApp: _zod.z.boolean(),
    connectWithEWallet: _zod.z.boolean(),
    isPrimary: _zod.z.boolean(),
    isVerified: _zod.z.boolean(),
    telephoneId: _zod.z.number().optional(),
    telephoneNumber: _zod.z.string().optional(),
    telephoneType: _zod.z.nativeEnum(_globalApiClientReact.GlobalCustomersPhoneDtoTelephoneType)
  });
  if (telephoneNumber?.validation?.isMandatory) {
    schema = schema.extend({
      telephoneNumber: _zod.z.string().optional().superRefine((value, ctx) => {
        if (!value || value === '') {
          return;
        }
        if (telephoneNumber?.validation?.regularExpression) {
          const regex = new RegExp(telephoneNumber.validation.regularExpression);
          if (!regex.test(value)) {
            ctx.addIssue({
              code: _zod.z.ZodIssueCode.custom,
              message: formatMessage(_TranslationKey.TranslationKey.validationRegex)
            });
          }
        }
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (telephoneNumber?.validation?.minLength && value.length < telephoneNumber.validation.minLength) {
          ctx.addIssue({
            code: _zod.z.ZodIssueCode.too_small,
            message: formatMessage(_TranslationKey.TranslationKey.validationLength),
            minimum: telephoneNumber.validation.minLength,
            inclusive: true,
            type: 'string'
          });
        }
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (telephoneNumber?.validation?.maxLength && value.length > telephoneNumber.validation.maxLength) {
          ctx.addIssue({
            code: _zod.z.ZodIssueCode.too_big,
            message: formatMessage(_TranslationKey.TranslationKey.validationLength),
            maximum: telephoneNumber.validation.maxLength,
            inclusive: true,
            type: 'string'
          });
        }
      })
    });
  }
  return schema;
};
exports.useGetSchema = useGetSchema;
//# sourceMappingURL=validationSchema.js.map